import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ISnListResponse, ISnListQueryParameters } from '@lib/api';
import { FsPermission } from 'libs/api/entities/src/lib/permission';

@Injectable({ providedIn: 'root' })
export class FsPermissionsAPI {
  constructor(private readonly _httpClient: HttpClient) {}

  public getPermissionsList(
    params?: ISnListQueryParameters,
  ): Observable<ISnListResponse<FsPermission>> {
    const url = '/api/permissions/list';

    return this._httpClient.get(url, { params }).pipe(
      map((response: any) => ({
        count: response.count,
        totalPages: response.totalPages,
        ordering: response.ordering,
        results: response.results.map((permission) => new FsPermission(permission)),
      })),
    );
  }
}
